module.exports = __webpack_public_path__ + "img/speed_icon.5d16c9c2.png";